export const blobToFile = async (
  fileBlob: Blob,
  fileName: string,
): Promise<File> => {
  return new File([fileBlob], fileName);
};
